import React from 'react'

import { GridItem } from '@thg-commerce/gravity-system'

import { BundleCategory } from '@thg-commerce/widget-build-your-own-bundle'
import { MAX_QUANTITY_SELECTION } from '@thg-commerce/widget-build-your-own-bundle/src/BuildYourOwnBundle'
import { StyledGrid } from './styles'

import { BundleProduct } from './ResponsiveBuildYourOwnBundleProducts'
import { BundleProductCard } from './BundleProductCard'

interface ProductCategoryContentProps {
  numberOfProductsInSelectedCategory: number
  productCategory: BundleCategory
  showProductReviews?: boolean
  showProductRRP?: boolean
  showPrices?: boolean
  showInfoButton?: boolean
  enableQuantitySelector?: boolean
  selectedBundleProducts: BundleProduct[]
  setSelectedBundleProducts: (
    callback: (currentProducts: BundleProduct[]) => BundleProduct[],
  ) => void
  availableBundleQuantitySelection: number
}

export const ProductCategoryContent = (props: ProductCategoryContentProps) => {
  return (
    <StyledGrid>
      {props.productCategory.skuList.map((product, index) => {
        return (
          <GridItem colSpan={[6, 4, 3, 3]} key={`${index}-${product.title}`}>
            <BundleProductCard
              product={product}
              numberOfProductsInSelectedCategory={
                props.numberOfProductsInSelectedCategory
              }
              categoryId={props.productCategory.id}
              setSelectedBundleProducts={props.setSelectedBundleProducts}
              selectedBundleProducts={props.selectedBundleProducts}
              showProductReviews={props.showProductReviews}
              maxProductsPerCategory={
                props.productCategory.maxProducts || MAX_QUANTITY_SELECTION
              }
              showInfoButton={props.showInfoButton}
              showPrices={props.showPrices}
              enableQuantitySelector={props.enableQuantitySelector}
              availableBundleQuantitySelection={
                props.availableBundleQuantitySelection
              }
            />
          </GridItem>
        )
      })}
    </StyledGrid>
  )
}
